module.exports = __webpack_public_path__ + "img/dummy-trainer.a4289931.png";